<!-- 预赛 -->
<template>
    <div v-if="rank" class="winner winners-pre-list">
      <div class="bg-buy">
        <div class="winner-w bg-buy--top">          
          <h3 class="winner-title">恭喜以下名单获得</h3>
          <h4 class="winner-intro">{{intro}}</h4>
          <ul class="winner-list bg-buy">
              <li v-for="winner in rank.list" :key="winner.uid"><k-user :nick="winner.mobile" :logo="winner.logoSrc" /></li>
          </ul>
        </div> 
      </div>
      <k-block name="winners_pre_bottom" />
    </div>
</template>

<script>
    export default {
        name: 'winners-pre-rank',
        props: ['intro', 'rank']
    }
</script>
